import { RecentFilesState } from '../Schema/RecentFilesState';
import { RecentFilesList } from '../Schema/RecentFilesList';
import { ObservableMap } from 'mobx';
import { createStore } from 'satcheljs';

// recentFilesPerGroup is a map from keys (group smtp address) to values (RecentFilesList)
export const getRecentFilesStore = createStore<RecentFilesState>('recentFilesStore', {
    recentFilesPerGroup: new ObservableMap<string, RecentFilesList>(),
});
